// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.login-footer[data-v-5c04ed3c]{\n  border-top: 1px solid var(--v-background-darken1) !important;\n}\n#company-info[data-v-5c04ed3c] {\n  font-size: 1rem;\n}\n#privacy-info[data-v-5c04ed3c] {\n  font-size: 0.8rem;\n}\n\n", ""]);
// Exports
module.exports = exports;
